export enum SubsidiaryStatusEnum {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}